import { useEffect, useState, useRef } from "react";

const cache = new Map();

export const usePolygonPreview = (
  geojson,
  { enabled },
  color,
  onDoneExternal,
) => {
  const [image, setImage] = useState(null);
  const keyRef = useRef(null);

  useEffect(() => {
    if (!enabled || !geojson) return;

    const key = JSON.stringify({ geojson, color });
    keyRef.current = key;

    if (cache.has(key)) {
      setImage(cache.get(key));
      return;
    }

    const renderer = window.__MAP_SCREENSHOT_RENDERER__;

    if (!renderer) {
      console.warn("Renderer not ready yet");
      return;
    }

    renderer.render({
      id: Math.random(),
      geojson,
      color,
      onDone: (img) => {
        cache.set(key, img);

        if (keyRef.current === key) {
          setImage(img);
        }
        onDoneExternal?.(img);
      },
    });
  }, [geojson, enabled, color, onDoneExternal]);

  return image;
};
